/**
 * Authentication Configuration
 * Settings for JWT authentication and token management
 */

export const AUTH_CONFIG = {
  /**
   * Token type expected from the backend
   */
  tokenType: 'Bearer',

  /**
   * Default token expiration (in seconds)
   * Used as fallback if backend doesn't specify
   */
  defaultExpiresIn: 3600, // 1 hour

  /**
   * Refresh token endpoint
   */
  refreshTokenEndpoint: '/auth/refresh',

  /**
   * Non-httpOnly flag cookie set by the backend alongside the httpOnly refresh token.
   * JavaScript can read this to know if a refresh token cookie exists
   * without attempting a wasted refresh request.
   */
  refreshTokenFlagCookie: 'rt_exists',

  /**
   * Routes that don't require authentication
   */
  publicRoutes: ['/login'],

  /**
   * Default redirect after login
   */
  loginRedirect: '/dashboard',

  /**
   * Default redirect after logout
   */
  logoutRedirect: '/login',
} as const;
